import { connect } from "react-redux";
import {
  scopeItems,
  scopesLoading,
  scopeStatusLoading,
  scopePagination,
  getError,
} from "../../store/selectors/scope.selector";
import {
  getScope,
  createScopeRequest,
  updateScopeRequest,
  deleteScopeRequest,
  duplicateScopeRequest,
  duplicateTaskRequest,
} from "../../store/actions/scope.actions";

import{ getProjectProgressSummary } from "../../store/actions/projects.actions";
import{ getProgramProgressSummary } from "../../store/actions/programs.actions";
import{ getPortFolioProgressSummary } from "../../store/actions/portfolio.actions";

import ScopeItem from "./ScopeItem";
import { getUsers } from "../../store/actions/user.actions";
const mapDispatchToProps = {
  getUsersRequest: getUsers,
  getScopeItemsRequest: getScope,
  createScopeRequest,
  updateScopeRequest,
  deleteScopeRequest,
  duplicateScopeRequest,
  duplicateTaskRequest,
  getProjectProgressSummary,
  getProgramProgressSummary,
  getPortFolioProgressSummary
};
const mapStateToProps = (state) => {
  const allScopeItems = scopeItems(state);
  const pageLoading = scopesLoading(state);
  const loading = scopeStatusLoading(state);
  const pagination = scopePagination(state);
  const error = getError(state);
  return {
    allScopeItems,
    pageLoading,
    loading,
    pagination,
    error,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScopeItem);
